import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { fromJS, Map } from 'immutable';
import { DialogService } from '../../../dialog/dialog.service';
import { Shipping } from '../../../document-data/sub-models/shipping.model';
import { IDatePickerFieldOptions } from '../../../form-master/components/date-picker-field/date-picker-field.component';
import { LoggerService } from '../../../shared/services/logger/logger.service';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import { TrackingObjectBuilder } from '../../../tracking/tracking-object.builder';
import {
  ITrackingAction,
  ITrackingObject,
  TrackingDialogNamesEnum,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { ShippingInfoDialogBuilder } from './shipping-info-dialog.builder';

export const DIALOG_TYPE = 'shipping-info';

@Component({
  selector: 'app-shipping-info-dialog',
  templateUrl: './shipping-info-dialog.component.html',
  styleUrls: ['./shipping-info-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [ShippingInfoDialogBuilder],
})
export class ShippingInfoDialogComponent implements OnInit, OnChanges {
  @Input() shipping: Shipping;
  @Input() locale: string;
  @Input() currencyCode: string;
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  @Output() onUpdateShippingInfo: EventEmitter<
    Map<string, any>
  > = new EventEmitter<Map<string, any>>();

  private _emptyForm: FormGroup;

  form: FormGroup;
  formKeys: any;
  dialogType: string;
  trackingObject: ITrackingObject;
  saveAction: ITrackingAction;
  cancelAction: ITrackingAction;
  shippingDateOptions: IDatePickerFieldOptions;

  constructor(
    private _dialogService: DialogService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _loggerService: LoggerService,
    private _shippingInfoDialogBuilder: ShippingInfoDialogBuilder,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder,
    private _trackingObjectBuilder: TrackingObjectBuilder
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.shipping) {
      this.form = this._shippingInfoDialogBuilder.buildForm(this.shipping);
      this._emptyForm = this._shippingInfoDialogBuilder.buildForm(null);
    }
  }

  ngOnInit() {
    this.dialogType = DIALOG_TYPE;
    this.formKeys = this._shippingInfoDialogBuilder.FORM_KEYS;
    this.trackingObject = this._trackingObjectBuilder.buildDialog(
      TrackingDialogNamesEnum.shipping_info
    );
    this.saveAction = this._trackingActionBuilder.buildButtonTapped(
      'save',
      this.trackingScreenName
    );
    this.cancelAction = this._trackingActionBuilder.buildButtonTapped(
      'cancel',
      this.trackingScreenName
    );
    this.shippingDateOptions = this._shippingInfoDialogBuilder.buildShippingDateOptions();
  }

  onSave() {
    this._loggerService.log('saving shipping info dialog');

    const documentContentProps = this._shippingInfoDialogBuilder.buildDocumentContentPropsFromShipping(
      fromJS(this.form.value),
      fromJS(this._emptyForm.value)
    );

    this.onUpdateShippingInfo.emit(documentContentProps);
  }
}
